import rawNeighborhoods from "./data/neighborhoods.json";
import type { Position } from "geojson";
import type { NeighborhoodCollection } from "./types";

// D3's spherical path renderer expects exterior rings clockwise. The source file
// follows RFC 7946's counterclockwise exterior convention, so reverse every ring
// once before rendering or calculating spherical centroids.
export const neighborhoods: NeighborhoodCollection = {
  type: "FeatureCollection",
  features: (rawNeighborhoods as NeighborhoodCollection).features.map((feature) => ({
    ...feature,
    geometry: feature.geometry.type === "Polygon"
      ? { ...feature.geometry, coordinates: feature.geometry.coordinates.map(reverseRing) }
      : { ...feature.geometry, coordinates: feature.geometry.coordinates.map((polygon) => polygon.map(reverseRing)) },
  })),
};

function reverseRing(ring: Position[]): Position[] {
  return [...ring].reverse();
}
